import { z } from 'zod';
import {
  EgressStrategySchema,
  TailscaleRoutingSnapshotSchema,
} from './proxy-context.dto';

export const ProxyTargetSchema = z.discriminatedUnion('type', [
  z.object({
    type: z.literal('DIRECT'),
    targetUrl: z.string().describe('Direct target URL for external apps'),
  }),
  z.object({
    type: z.literal('TENANT_NGINX'),
    proxyUrl: z.string().describe('Tenant-specific nginx proxy URL'),
    headers: z
      .record(z.string(), z.string())
      .describe('Additional headers (e.g., X-Terra-Target)'),
    socks5Url: z
      .string()
      .optional()
      .describe('SOCKS5 URL for raw TCP chaining into the egress pod'),
    socksDestinationHost: z
      .string()
      .optional()
      .describe('Optional rewritten SOCKS destination (4via6)'),
    socksFourViaSixResolve: z
      .boolean()
      .optional()
      .describe(
        'When true, resolve hostnames via Tailscale L3 egress MagicDNS→4via6 before dialing microsocks',
      ),
  }),
  z.object({
    type: z.literal('UPSTREAM_PROXY'),
    upstreamUrl: z
      .string()
      .describe('Upstream proxy URL to chain through (e.g., Bright Data)'),
    targetUrl: z.string().describe('Final target URL'),
  }),
]);

export type ProxyTargetDto = z.infer<typeof ProxyTargetSchema>;

export const RoutingParamsSchema = z.object({
  isInternalApp: z.boolean(),
  egressStrategy: EgressStrategySchema,
  tenantId: z.string(),
  targetUrl: z.string(),
  applicationId: z.string().optional(),
  tailscaleNetworkId: z.string().optional(),
  tailscaleRouting: TailscaleRoutingSnapshotSchema.optional(),
  twingateNetworkId: z.string().optional(),
});

export type RoutingParamsDto = z.infer<typeof RoutingParamsSchema>;
export type RoutingParamsInput = z.input<typeof RoutingParamsSchema>;
